import { style } from "@vanilla-extract/css";

import { theme } from "../../theme/css";

export const uploadCardStyle = style({
  width: "100% !important",
});

export const trailingStyle = style({
  position: "absolute",
  top: theme.spacings.xs,
  right: theme.spacings.s,
});
